<template>
  <div>
    <my-upload
      field="img"
      @crop-success="cropSuccess"
      :langType="'pt-br'"
      v-model="show"
      :width="400"
      :height="400"
      :noSquare="true"
      :noCircle="false"
      :url="''"
      img-format="png"
    ></my-upload>

    <form @submit.prevent="validateBeforeSubmit">
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="nome"
            v-validate="'required'"
            autocomplete="off"
            :class="{'is-invalid' : errors.has('nome')}"
            v-model.trim="form.nome"
            class="form-control form-control-sm"
          />
          <span class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="descricao"
            v-validate="'required'"
            autocomplete="off"
            :class="{'is-invalid' : errors.has('descricao')}"
            v-model.trim="form.descricao"
            class="form-control form-control-sm"
          />
          <span
            class="invalid-feedback"
            v-show="errors.has('descricao')"
          >{{ errors.first('descricao') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Ícone:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="icone"
            v-validate="'required'"
            autocomplete="off"
            :class="{'is-invalid' : errors.has('icone')}"
            v-model.trim="form.icone"
            class="form-control form-control-sm"
          />
          <span class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Sistema:</label>
        <div class="col-sm-10">
          <select
            v-model="form.id_sistema"
            autocomplete="off"
            class="form-control form-control-sm"
            name="sistema"
            @change="clickAddSistema(form.id_sistema)"
            :class="{'is-invalid' : errors.has('sistema')}"
          >
            <option value>Escolha</option>
            <option v-for="item in sistemas" :key="item.id" :value="item.id">{{item.nome}}</option>
          </select>
          <span
            class="invalid-feedback"
            v-show="errors.has('sistema')"
          >{{ errors.first('sistema') }}</span>

          <div>
            <button
              class="btn btn-sm btn-outline-primary"
              type="button"
              @click="form.modulos.splice(index, 1)"
              style="margin-right:5px; margin-bottom:5px; margin-top:5px"
              v-for="(item, index) in form.modulos"
              :key="item.id"
            >
              {{item.descricao}}
              <fa-icon icon="times"></fa-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">ID FollowAir:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="idFollowair"
            v-validate="'required'"
            autocomplete="off"
            :class="{'is-invalid' : errors.has('idFollowair')}"
            v-model.trim="form.idFollowair"
            class="form-control form-control-sm"
          />
          <span
            class="invalid-feedback"
            v-show="errors.has('idFollowair')"
          >{{ errors.first('idFollowair') }}</span>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-12 text-right">
          <small class="float-left text-info">
            <fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.
          </small>
          <button class="btn btn-success btn-sm">
            <fa-icon icon="check" transform="left-3" />SALVAR
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { mapState } from "vuex";
import _ from "lodash";
import axios from "../../../routers/axios";
export default {
  components: {
    myUpload
  },

  props: {
    perfil: {
      type: Boolean,
      required: false
    },
    perfis: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      show: false,
      requiredPass: "required",
      sistemas: [],
      imgDataUrl: "",
      form: {
        id: 0,
        nome: "",
        descricao: "",
        idFollowair: "",
        icone: "",
        id_sistema: ""
      }
    };
  },

  mounted() {
    axios.get(this._getUrl(`api/sistema`)).then(response => {
      if (response.status == 200) {
        this.sistemas = response.data;
      }
    });
  },

  computed: {
    ...mapState({
      config: state => state.sessao.config
    })
  },

  methods: {
    carregaUserPerfil(idModulo) {
      axios.get(this._getUrl(`api/modulo/${idModulo}`)).then(response => {
        this.editar(response.data);
      });
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.$notify.loadIn("Carregando foto");
      axios
        .post(this._getUrl("api/file"), { img: this.imgDataUrl })
        .then(response => {
          this.form.foto = response.data;
        });
    },

    editar(item) {
      this.requiredPass = "";
      this.form.id = item.id;
      this.form.nome = item.nome;
      this.form.descricao = item.descricao;
      this.form.idFollowair = item.idFollowair;
      this.form.icone = item.icone;
      this.form.id_sistema = item.idSistema;
    },

    validateBeforeSubmit() {
      this.form.id == 0
        ? (this.requiredPass = "required")
        : (this.requiredPass = "");

      this.$validator.validateAll().then(result => {
        if (result) {
          this.salva();
        }
      });
    },

    salva() {
      var data = {
        id: this.form.id,
        nome: this.form.nome,
        descricao: this.form.descricao,
        idFollowair: this.form.idFollowair,
        icone: this.form.icone,
        idSistema: this.form.id_sistema
      };

      this.$notify.loadIn("Salvando");

      if (this.form.id != 0) {
        axios
          .put(this._getUrl(`api/modulo/${this.form.id}`), data)
          .then(response => {
            this.$emit("item-salvo", response.data);
            // prop pra saber se tá importando o componente do meu "olá, [seu nome]"
            if (this.perfil) {
              this.$notify.show("success", "Módulo atualizado.");
            }
          });
      } else {
        axios.post(this._getUrl("api/modulo"), data).then(response => {
          this.$emit("item-salvo", response.data);
          this.form.id = response.data.id;
        });
      }
    }
  }
};
</script>

<style>
.vue-image-crop-upload .vicp-wrap {
  width: 300px !important;
  height: 470px !important;
}

.vicp-crop-right {
  float: left !important;
}

a.vicp-operate-btn:hover {
  color: #fff !important;
  background-color: #5cb85c !important;
  border-color: #4cae4c !important;
  text-decoration: none;
}

a.vicp-operate-btn {
  color: #fff !important;
  background-color: #5cb85c;
  border-color: #4cae4c;
  text-decoration: none;
}

.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-right
  .vicp-preview
  .vicp-preview-item {
  margin-left: 78px;
}
</style>



// WEBPACK FOOTER //
// src/views/adm/modulo-geral/cadastro.vue